import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskAreaDialogStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        cards: {
            display: "flex",
            flexDirection: "column",
            // DotLegalSection brings its own bottom margin, so only a small gap is added on top of it.
            gap: theme.spacing(1),
        },
        levelsCard: {
            maxHeight: "calc(100vh - 320px)",
            overflowY: "auto",
        },
        consequenceProbabilityRow: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(6),
        },
        // Name, responsible, assessment level, scale and appetite are the area's identity: five across on a wide
        // screen, three when that gets cramped, one on a phone.
        topRow: {
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: theme.spacing(1),
            alignItems: "start",
            [theme.breakpoints.down("lg")]: {
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            [theme.breakpoints.down("sm")]: {
                gridTemplateColumns: "1fr",
            },
        },
        appetiteReadout: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.5),
        },
        zoneSubtitle: {
            color: theme.palette.text.secondary,
            fontSize: "0.8rem",
            marginBottom: theme.spacing(2),
        },
        // The tooltip icon is absolutely positioned ~39px to the right of each field,
        // so reserve that space inside the column to keep it off the neighbouring field
        // and inside the dialog for the last column.
        topRowField: {
            paddingRight: theme.spacing(6),
        },
        contentColumns: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(3),
            alignItems: "stretch",
            // On smaller screens the two columns get too cramped, so stack the matrix under the levels section.
            [theme.breakpoints.down("lg")]: {
                gridTemplateColumns: "1fr",
            },
        },
        // The confirmation step holds a single column of prose and fields rather than cards, so it carries its
        // own horizontal breathing room where the cards would otherwise provide it.
        confirmation: {
            paddingX: theme.spacing(2),
        },
        matrixErrorText: {
            color: theme.palette.error.main,
            fontSize: "0.75rem",
            marginTop: theme.spacing(1),
        },
    });
};
